// ChessKid AI — Entry point
import './ui/styles/global.css';
import './ui/styles/board.css';
import './ui/styles/pages.css';
import { initRouter } from './router';
import { initSounds } from './audio/sound';
import { loadSettings } from './storage/settings';

// Initialize the app
document.addEventListener('DOMContentLoaded', () => {
  initSounds();
  initRouter();

  // Apply saved theme
  const settings = loadSettings();
  applyBoardTheme(settings.boardTheme);

  console.log('♔ ChessKid AI loaded');

  // Register service worker
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      console.log('Service Worker registered:', reg.scope);
    }).catch((err) => {
      console.log('Service Worker registration failed:', err);
    });
  }
});

const THEMES: Record<string, { light: string; dark: string }> = {
  classic: { light: '#f0d9b5', dark: '#b58863' },
  ocean: { light: '#dee3e6', dark: '#8ca2ad' },
  forest: { light: '#e8e4c7', dark: '#7a9a6d' },
  sunset: { light: '#f5e6d0', dark: '#d08b5b' },
  purple: { light: '#e8daf0', dark: '#8b6daa' },
};

function applyBoardTheme(theme: string): void {
  const t = THEMES[theme] || THEMES.classic;
  document.documentElement.style.setProperty('--board-light', t.light);
  document.documentElement.style.setProperty('--board-dark', t.dark);
}
